import React from 'react';
import {createRoot} from 'react-dom/client';
import ConnectedProducersListApp from "@sharedComponents/ConnectedProducersList/ConnectedProducersListApp";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const connectedProducersListBlocks = document.querySelectorAll('.js-connected-producers-list');
const queryClient = new QueryClient();

if (connectedProducersListBlocks.length) {
    connectedProducersListBlocks.forEach(hiddenInput => {
        const id = Number((hiddenInput as HTMLInputElement).value);
        const container = document.getElementById(`js-connected-producers-list-${id}`);
        if (container) {
            const root = createRoot(container);
            root.render(
                <QueryClientProvider client={queryClient}>
                    <ConnectedProducersListApp id={id}/>
                </QueryClientProvider>
            );
        }
    });
}